// Data
import propertyReportService from "data/reports-property"
import React, { FC } from "react"
// Styles
import { ButtonWithPress_s } from "styles/app-styles"

interface RentRollProps {
  property: object
}

const MFRentRoll: FC<RentRollProps> = (props) => {

  function submit():void {
    propertyReportService.propertyReport({
      report: 'multifamily_input_assumptions',
      params: {
        selected_reports: ["rent_roll"]
      }
    })
  }

  return (
    <div>
      <ButtonWithPress_s primary onClick={submit}>Run Report</ButtonWithPress_s>
    </div>
  )
}

export default MFRentRoll
